<ng2-slim-loading-bar [color]="color"></ng2-slim-loading-bar>